import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { getCurrentCompanyUUID } from "../../../utils/utils";

interface NavigationState {
  [key: string]: any;
}

const LOCAL_STORAGE_KEY = "navigationState";

const loadFromLocalStorage = (companyUUID: string): NavigationState => {
  try {
    const serializedState = localStorage.getItem(`navigationState_${companyUUID}`);
    if (serializedState === null) {
      return {};
    }
    const parsedState = JSON.parse(serializedState);
    if (parsedState && typeof parsedState === "object") {
      return parsedState as NavigationState;
    }
    return {};
  } catch (error) {
    console.error("Error loading navigation state from local storage:", error);
    return {};
  }
};

const companyUUID = getCurrentCompanyUUID();
const initialState: NavigationState = companyUUID ? loadFromLocalStorage(companyUUID) : {};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setNavigationData: (state, action: PayloadAction<NavigationState>) => {
      const companyUUID = getCurrentCompanyUUID();
      if (!companyUUID) {
        console.warn("No company UUID found for setNavigationData");
        return state;
      }

      const newState = { ...state, ...action.payload };
      // Save to local storage
      try {
        localStorage.setItem(`navigationState_${companyUUID}`, JSON.stringify(newState));
      } catch (error) {
        console.error("Error saving navigation state to local storage:", error);
      }
      return newState;
    },
    resetNavigationData: () => {
      // Clear local storage
      const companyUUID = getCurrentCompanyUUID();
      if (companyUUID) {
        try {
          localStorage.removeItem(`navigationState_${companyUUID}`);
        } catch (error) {
          console.error("Error clearing navigation state from local storage:", error);
        }
        return {};
      }
    },
  },
});

export const { setNavigationData, resetNavigationData } = navigationSlice.actions;
export default navigationSlice.reducer;
export const selectNavigationData = (state: RootState) => state.navigation;